
<style>
    .closeTrngMdl {
        padding: 6px 13px !important;
        position: absolute;
        right: -15px;
        top: -15px;
        background-color: #15304a;
        border-radius: 3px;
        font-size: 18px !important;
        cursor: pointer;
        z-index: 1;
        border-radius: 50%;
        color: #fff;
    }

    .closeTrngMdl:hover {
        background-color: #f0f0f0;
        color: #15304a;
        outline: 1px solid #15304a !important;
    }

    @media only screen and (max-width: 768px) {
        .widthAuto {
            width: auto !important;
        }
        .modal-content {
            min-height: auto !important;
        }
    }
</style>
<!-- Modal Content -->
<div class="modal-content bgGrey" style="border-radius: 10px !important; ">
    <div class="modal-body" style="padding: 0px; text-align:left;">
        <div class="col-md-12 col-sm-12 col-xs-12 pad0">
            <div class="col-md-12 col-sm-12 col-xs-12 pad0" style="font-size: 22px; text-align: left;">
                <span (click)="changeVideoActions('stop',trainingModule.moduleID)" class="closeTrngMdl" data-dismiss="modal">
                    <i class="zmdi zmdi-close" style="position: relative; top: 1px;"></i>
                </span>
            </div>
            <div class="col-md-12 col-sm-12 col-xs-12 pad0" style="margin-bottom:15px; margin-top:0px;">
                <div class="col-md-12 col-sm-12 col-xs-12 pad0" style="font-weight: 400; text-align: left; display: flex; flex-wrap: wrap; gap: 10px;">
                    <img (click)="changeVideoActions('play', trainingModule.moduleID)" [src]="trainingModule.thumbnailID" style="width: -webkit-fill-available; border-radius:10px; border:5px solid #f8f8f8; cursor: pointer;" *ngIf="!trainingModule.showVideo">
                    <iframe class="height200" *ngIf="trainingModule.showVideo" style="width: -webkit-fill-available; height: 300px; border-radius:15px; border:5px solid #f8f8f8;" [src]="trainingModule.videoID" allowfullscreen allow="autoplay"></iframe>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer" style="padding: 0px 15px 15px; border: none; text-align: center; display: flex; justify-content: center;">
        <span class="btn-darkBlue" title="Sales Analysis" style="margin-right: 10px; color: #fff; border-radius: 3px; line-height: 18px; padding: 5px 8px 5px;" (click)="changeVideoActions('play', trainingModule.moduleID)">
                <i class="fa fa-youtube-play" style="margin-right: 5px; vertical-align: initial; font-size: 15px;"></i> Watch Training
        </span>
        <span class="orangeButton" title="Sales Analysis" style="padding: 5px 15px !important;" data-dismiss="modal" (click)="changeVideoActions('stop',trainingModule.moduleID)">
            <i class="fa fa-arrow-right" style="margin-right: 5px; vertical-align: initial; font-size: 15px;"></i> Start Using
        </span>
    </div>
</div>